module.exports = __webpack_public_path__ + "media/images/top-4-66fc18fc19b9a4a48eb465122a34c7e3.png";